import Svg, { Path } from "react-native-svg";

/**
 * A `−`, for a quantity stepper's decrease control.
 *
 * The designer's export, made into a component: it arrived as an `<svg>` element at the top
 * level of a `.tsx` — which is not a component — with `#634090` baked into the fill. That is one
 * merchant's brand colour, and every surface that draws this one takes the CURRENT merchant's,
 * so `color` is required and has no default.
 *
 * ## Two things were dropped, and both were no-ops
 *
 * The `<mask>` clipped the drawing to a 24×24 `<rect>` covering the whole canvas, so it removed
 * nothing — Material's exporter emits it whether or not a shape overflows. Carrying it would
 * mean carrying a document-wide `id` into every instance of this icon on the page, which is the
 * usual reason one copy of an SVG icon renders blank while the rest are fine.
 *
 * ⚠️ **The viewBox is the INK, not the canvas**, and that is what makes `size` mean the same
 * thing it meant for the `MinusGlyph` this replaces: the bar spans x 5→19 of the 24-unit canvas,
 * so `5 5 14 14` crops the artwork's optical padding and leaves the mark filling its box —
 * horizontally exactly, and vertically centred on the box's middle (the bar's own centre is at
 * y 12, which is the centre of that viewBox). Drawn at the canvas's own `0 0 24 24` the mark
 * would be 58% of the size every caller asks for, and every stepper in the kiosk would need a
 * new number.
 */
export function MinusIcon({ color, size = 14 }: { color: string; size?: number }) {
  return (
    <Svg width={size} height={size} viewBox="5 5 14 14" fill="none">
      <Path d="M5 13V11H19V13H5Z" fill={color} />
    </Svg>
  );
}
MinusIcon.displayName = "MinusIcon";
export default MinusIcon;
